import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useUserManagementClientContext } from './UserManagementClientContext';

export const useGetAllManagedLicenses = () => {
  const client = useUserManagementClientContext();
  const { data } = useQuery({
    queryKey: ['AllManagedLicenses'],
    queryFn: client.getMyLicenses,
  });

  const managedLicenses = useMemo(
    () => (data && data.filter((l) => l.type === 'FromSubscription')) ?? [],
    [data],
  );
  return { managedLicenses };
};
